import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaTrashAlt, FaEdit } from 'react-icons/fa'
import api from '../../services/api';
import { toast } from 'react-toastify';
import { updateImage } from '../utils/updateImage';

/* Material UI */
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import './styles.css';
import Table from "./Table";
import MultiManual from '../../components/Manual/MultiManual';

//alerta
import Notification from '../../components/Notification/Notification';
import ConfirmDialog from '../../components/Notification/ConfirmDialog';
import UserPermission from '../../components/UserPermission';
import { Card, CardContent, Grid, MenuItem, Typography } from '@mui/material';
import { toBase64 } from '../utils/toBase64';
import useWindowDimensions from '../../components/Sidebar/WindowDimensions';

export default function CadastroDeCategoria() {
  const history = useNavigate();

  const { width } = useWindowDimensions();

  // Permissão do usuário no sistema
  let userPermission = UserPermission();

  useEffect(() => {
    if (userPermission !== 'admin') {
      toast.error("Seu usuário não possuí privilégios para acessar essa página!");
      history("/search");
    }
  }, [userPermission, history]);

  const [name, setName] = useState('');
  const [target, setTarget] = useState('');
  const [grupo, setGrupo] = useState('');
  const [timeOfAttendance, setTimeOfAttendance] = useState('');
  const [description, setDescription] = useState('');
  const [areas, setAreas] = useState([]);
  const [refresh, setRefresh] = useState(true);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '', title: '' });
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' });
  const [allGroups, setAllGroups] = useState([]);
  const [icon, setIcon] = useState();
  const [inputIcon, setInputIcon] = useState(null)

  const classes = {
    textField: {
      width: '100%',
      backgroundColor: '#fff',
    },
    buttonSubmit: {
      marginTop: 20,
    },
    formControl: {
      marginLeft: 5,
      marginTop: 16,
      width: '50%'
    },
    textTitle: {
      margin: 8,
      color: '#103168',
      fontWeight: 600,
      marginBottom: 30,
    },
    buttonConfirm: {
      backgroundColor: '#1551B3',
      color: '#fff',
      borderRadius: 20,
      height: '45px',
      textTransform: 'capitalize',
      fontWeight: 'bold',
      fontSize: 15,
      marginTop: '17px',
      minWidth: '220px'
    },
    message: {
      padding: 10,
      backgroundColor: '#FFFBE8',
      color: 'rgba(0,0,0,0.8)',
      borderRadius: 7,
      width: '100%'
    },
    cardRoot: {
      borderRadius: '17px',
      backgroundColor: '#F5F5F5',
      boxShadow: 'none',
    },
    labelInput: {
      fontFamily: 'Rawline',
      color: '#333333',
      fontWeight: 'bold',
      paddingLeft: 2,
      fontSize: 14,
      marginBottom: '0.5rem'
    },
    inputFile: {
      border: 'dashed 2px #BABABA',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 10,
      height: 55.972,
      borderRadius: 5,
      padding: '13px 10px',
      textAlign: 'center',
      fontFamily: 'Rawline',
      backgroundColor: 'white'
    },
    heightAdjust: {
      height: (width > 600 && 1200 > width ? 42 : 'auto')
    }
  };

  useEffect(() => {
    api.get('groups')
      .then((response) => {
        setAllGroups(response.data);
      })
  }, []);


  /* Função para deletar uma categoria */
  const handleDeleteArea = useCallback(async (id) => {
    try {
      await api.delete(`/admin/areas/${id}`);
      setNotify({
        isOpen: true,
        message: 'Tipo deletado com sucesso.',
        type: 'error',
        title: 'Deletado',
      });

      setRefresh(true);

    } catch (err) {
      const statusCodeKnown = [422];
      const statusCode = err?.response?.status;
      let message = err?.response?.data?.error?.message;

      if (!statusCodeKnown.includes(statusCode)) {
        message = 'Erro desconhecido ao deletar tipo, tente novamente.';
      }

      setNotify({
        isOpen: true,
        message,
        type: 'error',
        title: 'Erro',
      });

    } finally {
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false,
      })
    }
  }, [confirmDialog]);

  // Função alerta para deletar área
  const deleteAreaDialog = useCallback((dados) => {
    setConfirmDialog({
      isOpen: true,
      title: 'Você gostaria de deletar esse tipo ?',
      subTitle: 'Esta ação não poderá ser desfeita',
      onConfirm: () => { handleDeleteArea(dados) }
    })
  }, [handleDeleteArea]);

  const cleanFields = () => {
    setName('');
    setTimeOfAttendance('');
    setGrupo('');
    setDescription('');
  }

  /* Colunas da tabela */
  const columns = useMemo(
    () => [
      {
        Header: 'Nome',
        accessor: 'name',
      },
      {
        Header: 'Grupo',
        accessor: 'group',
        Cell: ({ row }) => (
          <span>{row.original.group?.nameSecretary || "Sem Grupo"}</span>
        )
      },
      {
        Header: 'Serviço de Destino',
        accessor: 'target',
      },
      {
        Header: 'Tempo de Atendimento',
        accessor: 'timeOfAttendance',
        Cell: ({ row }) => (
          <span>{row.original.timeOfAttendance || "Não informado"}</span>
        )
      },
      {
        // Make an expander cell
        Header: () => null, // No header
        id: 'edit', // It needs an ID
        Cell: ({ row }) => (
          // <Link to={`/useredit/${row.original.id}`}>
          <Link to={`/type-edit/${row.original.id}`}>
            <FaEdit
              size={20}
              color="#1351B4"
            />
          </Link>
        ),
      },
      {
        Header: () => null, // No header
        id: 'expander', // It needs an ID
        Cell: ({ row }) => (
          <Link to="#">
            <FaTrashAlt
              size={20}
              color="#1351B4"
              onClick={() => {
                deleteAreaDialog(row.original.id)
              }}
            />
          </Link>)
      }
    ], [deleteAreaDialog]
  )

  useEffect(() => {
    const data = {
      include: ['group']
    };

    if (refresh === true) {
      if (userPermission === 'admin') {
        api.get(`${userPermission}/areas?filter=${JSON.stringify(data)}`).then(response => {
          setAreas(response.data);
        });
        setRefresh(false);
      }
    }
    if (userPermission === 'admin') {
      api.get(`${userPermission}/areas?filter=${JSON.stringify(data)}`).then(response => {
        setAreas(response.data);
      });
    }
  }, [userPermission, refresh]);

  //chama o alerta para cadastrar
  function confirms(dados) {
    dados && dados.preventDefault();

    toBase64(icon).then((base64) => {
      const data = {
        name,
        description,
        groupId: grupo,
        timeOfAttendance: parseInt(timeOfAttendance),
        target: target,
        picture: {
          type: icon.type,
          body: base64,
          url: ""
        }
      };

      setConfirmDialog({
        isOpen: true,
        title: `Você está cadastrando um tipo ${name}?`,
        subTitle: `Confirme a informação pois não será possível trocar o termo "${name}" após cadastro de ocorrências nesse tipo.`,
        onConfirm: () => { handleRegistrerArea(data) }
      })
    });
  }

  /* Função para cadastrar uma categoria */
  async function handleRegistrerArea(data) {
    /* Verifica se o usuário escreveu alguma coisa no input da categoria */
    if (!data.name) {
      setNotify({
        isOpen: true,
        message: 'Preencha o campo Tipo para cadastrar um Tipo.',
        type: 'warning'
      });
      setConfirmDialog({
        ...confirmDialog,
        isOpen: false,
      });

      /* Verifica se a área informada já existe */
    } else if (areas.some(res => res.name.toLowerCase() === data.name.toLowerCase())) {
      setNotify({
        isOpen: true,
        message: 'A área relatada já existe.',
        type: 'warning'
      });

      setConfirmDialog({
        ...confirmDialog,
        isOpen: false,
      });

      /* Caso as duas condições sejam falsas, realiza o cadastro da área */
    } else {
      try {
        await api.post("admin/areas", data);

        const dataa = {
          include: ['group']
        };
    
          if (userPermission === 'admin') {
            api.get(`${userPermission}/areas?filter=${JSON.stringify(dataa)}`).then(response => {
              setAreas(response.data);
            });
          }
        
        /* recarrega a página para renderizar a categoria na lista */
        //setRefresh(true); // atualizar tabela 

        cleanFields(); // deixa o nome vazio


        // fecha janela após cadastrar
        setConfirmDialog({
          ...confirmDialog,
          isOpen: false,
        });

        // janela de notificação de sucesso
        setNotify({
          isOpen: true,
          message: 'Tipo cadastrada com sucesso.',
          type: 'success',
          title: 'Cadastrada'
        });

      } catch (err) {
        setNotify({
          isOpen: true,
          message: 'Ocorreu um erro ao cadastrar um tipo.',
          type: 'error',
          title: 'Erro',
        });

        setConfirmDialog({
          ...confirmDialog,
          isOpen: false,
        })
      }
    }
  };

  if (userPermission !== 'admin') {
    return null;
  } else {
    return (
      <div className="cadastro-container">
        <form onSubmit={confirms}>
          <Card style={classes.cardRoot}>
            <CardContent>

              <Typography variant="h5" align="center" style={classes.textTitle}>
                Cadastro de tipos de Ocorrências
              </Typography>

              <div style={classes.message}>
                Preencha o formulário abaixo para cadastrar um tipo de ocorrência
                relacionadas ao código de postura do município ou serviços prestados à comunidade.
              </div>

              <Grid id="form-inputs" container spacing={2} alignItems="center" justifyContent="center" style={{ marginTop: 20 }}>
                <Grid item xs={12} sm={12} md={8}>
                  <Typography style={{ ...classes.labelInput, ...classes.heightAdjust }}>
                    Nome do Tipo: *
                  </Typography>

                  <TextField
                    style={{ background: '#fff' }}
                    required
                    fullWidth
                    value={name}
                    onChange={e => setName(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4}>
                  <Typography style={{ ...classes.labelInput, ...classes.heightAdjust }}>
                    Selecione uma imagem para este tipo: *
                  </Typography>

                  <div style={classes.inputFile}>
                    <input
                      accept="image/*"
                      label='Icone'
                      type='file'
                      style={{ width: "100%" }}
                      onChange={(e) => {
                        updateImage(e.target.files[0], setInputIcon);
                        setIcon(e.target.files[0])
                      }}
                      required
                    />
                    <div style={{ width: '20%' }}>
                      <img src={inputIcon} width={30} height={30} alt="Ícone da categoria" />
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} sm={12} md={4}>
                  <Typography style={{ ...classes.labelInput, ...classes.heightAdjust }}>
                    Tempo de previsão de atendimento (em dias): *
                  </Typography>

                  <TextField
                    style={{ background: '#fff' }}
                    required
                    type='number'
                    fullWidth
                    value={timeOfAttendance}
                    onChange={e => setTimeOfAttendance(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Typography style={{ ...classes.labelInput, ...classes.heightAdjust }}>
                    Grupo: *
                  </Typography>

                  <FormControl variant="outlined" required fullWidth>
                    <Select
                      style={{ background: '#fff' }}
                      value={grupo}
                      onChange={e => setGrupo(e.target.value)}
                    >
                      {
                        allGroups.map((group) => (
                          <MenuItem key={group.id} value={group.id}>{group.nameSecretary}</MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <Typography style={{ ...classes.labelInput, ...classes.heightAdjust }}>
                    Serviço de Destino: *
                  </Typography>

                  <FormControl variant="outlined" required fullWidth>
                    <Select
                      style={{ background: '#fff' }}
                      value={target}
                      onChange={e => setTarget(e.target.value)}
                    >
                      <MenuItem value={'Cidadão'}>Cidadão</MenuItem>
                      <MenuItem value={'Visão'}>Visão</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12}>
                  <Typography style={classes.labelInput}>
                    Descrição: *
                  </Typography>

                  <TextField
                    required
                    fullWidth
                    style={{ backgroundColor: '#fff' }}
                    multiline
                    rows={4}
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                  />
                </Grid>

              </Grid>

            </CardContent>
          </Card>

          <Grid container spacing={2} alignItems="center" justifyContent="center">
            <Grid item>
              <Button
                id='register-button'
                variant="outlined"
                type='submit'
                startIcon={<FaEdit style={{ 'color': '#fff' }} />}
                onClick={() => confirms()}
                style={classes.buttonConfirm}
              >
                Cadastrar Tipo
              </Button>
            </Grid>
          </Grid>
        </form>

        <hr></hr>

        <Card id='types-list' style={classes.cardRoot}>
          <CardContent>
            <div className='tabela'>

              <Typography variant="h5" align="center" style={classes.textTitle}>
                Listagem de Tipos de Ocorrências
              </Typography>

              <div style={classes.message}>
                Abaixo será listado os tipos cadastrados no sistema.
                É possível editar ou excluir um tipo selecionando uma das opções a direita da tabela.
              </div>
              <Table columns={columns} data={areas} />
            </div>
          </CardContent>
        </Card>


        <Notification
          notify={notify}
          setNotify={setNotify}
        />
        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />

        <MultiManual
          components={[
            {
              id: 'form-inputs',
              message: 'Você pode preencher este formulário com os dados de um novo tipo',
              rect: { height: 20, top: -20 }
            },
            {
              id: 'register-button',
              message: 'Aperte o botão para confirmar o cadastro',
              rect: { height: 20, top: -20 }
            },
            {
              id: 'types-list',
              message: 'Aqui é a lista de tipos',
              rect: { height: 20, top: -20 }
            }

          ]}
        />
      </div>
    );
  }
}